export default class AltcraftPush {
  constructor(AKPush) {
    this.pushInstance = AKPush;
  }

  async subscribe(target, email) {
    if (Notification.permission === 'denied') {
      return new Error('AKPush: Notification permission is denied');
    }

    const match = {
      email: email || null,
    };

    if (Notification.permission === 'granted') {
      this.pushInstance.updateSubscription(
        match,
        {
          [target]: true,
        },
      );
    } else {
      this.pushInstance.initSubscription(
        match,
        {
          [target]: true,
        },
      );
    }

    return new Promise((resolve, reject) => {
      window.AKPush.events.on('subscribe', () => {
        resolve();
      });

      window.AKPush.events.on('update_subscription', () => {
        resolve();
      });

      setTimeout(() => {
        reject(new Error('AKPush: service timeout for 10 sec'));
      }, 10000);
    });
  }
}
